const applicationDetail = {
  titleOne: '我们的客户',
  titleTwo: '产品应用',
  titleThree: '产品应用与解决方案',
  titleFour: '行业案例',
}


export default {
  title: '应用领域',
  titleOne: 'KELK 多领域流体专家',
  contentOne: `
  深耕石油炼化、清洁能源、冶金智造等严苛工况领域六十载，无锡凯尔克以超低温深冷阀、核级主蒸汽调节阀等尖端流体控制产品，定义工业安全与效能标杆。从LNG超临界储运到氢能超高压控制，从智能冶金高炉到环保脱硫装置，我们以多级降压迷宫阀芯、金属波纹管动态密封等18项专利技术，为全球工业巨头定制研发ASME B16.34/API 6D标准的高端控制设备及全生命周期管理服务，用中国精度重塑全球工业控流标准。
  `,
  applicationDetail,
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/applicationAreaPage.js